/**
 * TODO(catherton): configure a spec context for these utils
 */
import { get } from 'lodash'

export const getMarketingAttribute = (listing, attributeType) =>
  get(listing, 'marketing_attributes', []).find(
    elem => elem?.attribute_type === attributeType
  ) || {}

/**
 * NOTE: Be careful when working with these attribute types. Just because they have a message set, per the specs we
 * shouldn't use it unless `show` is also set. They may be configuring something ready for a new auction without meaning
 * to apply it yet and we should take that into consideration.
 */
export const getShowableContentAttribute = (...args) => {
  const attr = getMarketingAttribute(...args)

  return attr.show ? attr.message : ''
}
